export enum REFERENCE_CODE {
  /** オプトインの有効期間(日数) */
  INT_U_0001 = 'INT_U_0001',
  /** 営業モジュールの対象チャネルコードリスト */
  STR_M_0001 = 'STR_M_0001',
  /** ヘッダチェックスキップ対象モジュールリスト */
  STR_M_0006 = 'STR_M_0006',
  /** メール送信回数カウントアップ対象送信タイプ */
  STR_M_0012 = 'STR_M_0012',
  /** 経路タイプリスト */
  STR_M_0013 = 'STR_M_0013',
  /** 顧客情報照会利用可能フラグリスト */
  STR_M_0015 = 'STR_M_0015',
  /** ログレベル */
  STR_M_0018 = 'STR_M_0018',
  /** チャネルコード */
  STR_M_0020 = 'STR_M_0020',
  /** メール送信ステータス */
  STR_M_0022 = 'STR_M_0022',
  /** メール表示内容フォーマット（個別） */
  STR_M_0023 = 'STR_M_0023',
  /** メール表示内容フォーマット（一斉） */
  STR_M_0024 = 'STR_M_0024',
  /** メール表示内容フォーマット（許諾） */
  STR_M_0025 = 'STR_M_0025',
  /** オプトイン登録用ジャンルID(SBM) */
  STR_U_0002 = 'STR_U_0002',
  /** オプトイン更新用ジャンルID(SBM) */
  STR_U_0003 = 'STR_U_0003',
  /** 件名 */
  STR_U_0004 = 'STR_U_0004',
  /** 遠隔操作URL */
  STR_U_0005 = 'STR_U_0005',
  /** ダミー用店舗コード */
  STR_U_0007 = 'STR_U_0007',
  /** オプトイン登録用ジャンルID(YM) */
  STR_U_0008 = 'STR_U_0008',
  /** オプトイン更新用ジャンルID(YM) */
  STR_U_0009 = 'STR_U_0009',
  /** 問い合わせ先URL（SBM） */
  STR_U_0010 = 'STR_U_0010',
  /** 問い合わせ先URL（YM） */
  STR_U_0011 = 'STR_U_0011',
  /** シフト個人予定フラグ */
  STR_U_0014 = 'STR_U_0014',
  /** 事前顧客照会同意ステータス未確認フラグ */
  STR_U_0016 = 'STR_U_0016',
  /** スケジュール管理システムコード */
  STR_U_0017 = 'STR_U_0017',
  /** 来店予約URL（SBM） */
  STR_U_0019 = 'STR_U_0019',
  /** 来店予約URL（YM） */
  STR_U_0021 = 'STR_U_0021',
  /** クルーナビURLのパス（お客さま情報の取り扱いについて）*/
  STR_U_0024 = 'STR_U_0024',
  /** クルーナビURLのパス（店舗からのメール送信機能について） */
  STR_U_0025 = 'STR_U_0025',
  /** パーミッションモーダルに表示するリンク(ソフトバンクのプライバシーポリシーURL) */
  STR_U_0032 = 'STR_U_0032',
}
